export * from './useGetContent';
export * from './useGetHeading';
